module.exports = "/assets/data/72347b65552180fb03ca633b88afa005-G78.data.json";